import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-800">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20atmospheric%20scene%20of%20thick%20fog%20swirling%20over%20an%20ancient%20archive%20table%20covered%20in%20scattered%20aged%20papers%20and%20sealed%20folders%2C%20deep%20charcoal%20shadows%20with%20warm%20amber%20candle%20glow%2C%20mysterious%20occult%20mood%2C%20cinematic%20wide%20shot%20with%20heavy%20vignette%20and%20film%20grain%2C%20no%20people%20no%20text&width=1920&height=1080&seq=lieqi-hero-bg-2026&orientation=landscape"
          alt="猎奇吃瓜 悬疑档案氛围图"
          title="猎奇吃瓜 - 未解之谜与悬疑档案"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/70 to-background-950/95" />

      <div className="relative mx-auto flex w-full max-w-content flex-col justify-center px-4 py-20 md:px-6 md:py-28 lg:py-32">
        <div className="w-full max-w-3xl">
          <p className="flex items-center gap-2 text-xs tracking-[0.32em] text-primary-400">
            <span className="h-px w-8 archive-rule" />
            悬案 · 异闻 · 观察记录
          </p>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-50 md:text-5xl lg:text-6xl">
            猎奇吃瓜
          </h1>
          <p className="mt-4 font-heading text-xl font-semibold text-foreground-100 md:text-2xl">
            深挖未解之谜、灵异杂谈与都市传说
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
            超自然现象、悬疑档案、暗网传闻持续更新。我们把零散的线索整理成可以翻阅的卷宗，让你在每一次翻页里，都能离真相更近一点。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/archives"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-folder-open-line" /> 进入档案库
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-50/25 px-6 py-3 text-sm font-medium text-foreground-100 transition-colors hover:border-primary-400 hover:text-primary-300"
            >
              <i className="ri-information-line" /> 了解我们
            </Link>
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-3 gap-4 border-t border-foreground-50/15 pt-6">
            <div>
              <dt className="text-xs text-foreground-400">已归档档案</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-300 md:text-3xl">
                {articles.length * 27}+
              </dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-400">题材分类</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-300 md:text-3xl">{categories.length}</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-400">每周更新</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-300 md:text-3xl">2-3 篇</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}